import { render, staticRenderFns } from "./PostEditoCreateInstagram.vue?vue&type=template&id=770d7e71&scoped=true&"
import script from "./PostEditoCreateInstagram.vue?vue&type=script&lang=js&"
export * from "./PostEditoCreateInstagram.vue?vue&type=script&lang=js&"
import style0 from "./PostEditoCreateInstagram.vue?vue&type=style&index=0&id=770d7e71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770d7e71",
  null
  
)

export default component.exports